import { AppState } from "../../store";
import { ReportCampaignListItem, reportCampaignListSelector } from "./report-param-form-selectors";
import { ReportUrl } from "@common";

export function currentReportCampaign(appState: AppState): ReportCampaignListItem | undefined {
    const urlMatch = ReportUrl.match(window.location.toString(), true);

    if (urlMatch.isMatched) {
        return reportCampaignListSelector(appState).find(c => c.campaignId === urlMatch.params.campaignId);
    }

    return undefined;
}
